import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiItemsListHelperService } from '../../../fi-items-list/fi-items-list-helper.service';
import { IForm } from '../../../fi-form-shared/fi-form-shared';

@Component({
    selector: 'fi-checklist2-list-extended-search',
    template: `
        <fi-checklist2-list
            [extendedSearchMode]="true"
            (selectionChanged)="onSelectionChanged($event)"
        ></fi-checklist2-list
        >,
    `,
    styleUrl: './fi-checklist2-list-extended-search.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-list-extended-search' },
    standalone: false,
})
export class FiChecklist2ListExtendedSearchComponent {
    constructor(private itemsListHelperService: FiItemsListHelperService) {}

    onSelectionChanged($event: IForm[]) {
        this.itemsListHelperService.triggerExtendedSearchSelectionChanged($event);
    }
}
